import { render, staticRenderFns } from "./DashboardRequest.vue?vue&type=template&id=4589b0dc"
import script from "./DashboardRequest.vue?vue&type=script&lang=ts"
export * from "./DashboardRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4589b0dc')) {
      api.createRecord('4589b0dc', component.options)
    } else {
      api.reload('4589b0dc', component.options)
    }
    module.hot.accept("./DashboardRequest.vue?vue&type=template&id=4589b0dc", function () {
      api.rerender('4589b0dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/cards/DashboardRequest.vue"
export default component.exports